import { chatRunTask, chatSendStream } from '../../../lib/backend/chat';
import { getAccessToken } from './openclawSession';

export async function streamAgentMessage(agentId, message, { onChunk, signal } = {}) {
  const token = await getAccessToken();
  let acc = '';

  await chatSendStream(
    token,
    message,
    agentId,
    (text) => {
      acc += text;
      onChunk?.(text, acc);
    },
    signal
  );

  return acc;
}

export async function runAgentTask(agentId, message, { taskId } = {}) {
  const token = await getAccessToken();
  return chatRunTask(token, message, agentId, taskId);
}
